export default "__VITE_ASSET__7a706b63__"